import { UpdateProfileForm } from '~/components/user/UpdateProfileForm';

export default function ProfileIndexRoute() {
  return <UpdateProfileForm />;
}
